// extracted by mini-css-extract-plugin
export default {"recos":"S5-z","productCardOverride":"T5-z","rowHasBadge":"U5-z"};